import { createFileRoute } from "@tanstack/react-router";
import { PolicyPage } from "@/components/PolicyPage";

export const Route = createFileRoute("/policies/privacy-policy")({
  head: () => ({
    meta: [
      { title: "Privacy Policy — Coyote Creek Hat Co." },
      { name: "description", content: "How Coyote Creek Hat Co. collects, uses, and protects your personal information when you shop our Texas-made hats and apparel online." },
      { property: "og:title", content: "Privacy Policy — Coyote Creek Hat Co." },
      { property: "og:description", content: "How Coyote Creek Hat Co. collects, uses, and protects your personal information when you shop our Texas-made hats and apparel online." },
      { property: "og:url", content: "https://coyotecreekhatco.com/policies/privacy-policy" },
    ],
    links: [{ rel: "canonical", href: "https://coyotecreekhatco.com/policies/privacy-policy" }],
  }),
  component: () => <PolicyPage policyKey="privacyPolicy" fallbackTitle="Privacy Policy" />,
});
